import { render, staticRenderFns } from "./LabelPersonTaskSum.vue?vue&type=template&id=fd9b4b96&scoped=true"
import script from "./LabelPersonTaskSum.vue?vue&type=script&lang=js"
export * from "./LabelPersonTaskSum.vue?vue&type=script&lang=js"
import style0 from "./LabelPersonTaskSum.vue?vue&type=style&index=0&id=fd9b4b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9b4b96",
  null
  
)

export default component.exports